module.exports = __webpack_public_path__ + "e6d6d460c9c9dc7f97bf84236215b3b6.png";